export default __webpack_public_path__ + "static/media/propellerHat.ba2f591b.png";